import { AnalyticsStore } from "bernie-core";
import { sendImmediateTrackEvent, FlexTrackingInfo, Action } from "components/utility/analytics/FlexAnalyticsUtils";

/**
 * Utility class to track how far a user scrolls down the page.
 * In particular, it tracks the max percentage of scroll down the page in intervals of 10% and sends a track event on page exit.
 *
 * e.g. User scrolls down 57% of the page, then scrolls back to the top and leaves the page.
 *      - This will send a track event with referrer id: blossom.scroll.50.scroll
 */
export class ScrollTracker {
  private currentMaxScroll = 0;
  private documentHeight = 0;
  constructor(private analyticsStore?: AnalyticsStore) {}

  public track() {
    if (!this.analyticsStore || typeof window === "undefined") {
      return;
    }

    this.documentHeight = document.documentElement.scrollHeight;
    this.setupAndTrackScrollOnExit();
  }

  private setupAndTrackScrollOnExit() {
    if (!this.documentHeight) {
      return;
    }

    window.addEventListener("scroll", this.checkAndMaintainMaxScroll);
    window.addEventListener("beforeunload", this.sendMaxScrollYTrackEvent);
  }

  private checkAndMaintainMaxScroll = () => {
    const currentScroll = window.scrollY || document.documentElement.scrollTop;

    // Get the rounded percentage of scrolled page by intervals of 10
    const scrollPercentage = Math.floor(((currentScroll / this.documentHeight) * 100) / 10) * 10;

    if (scrollPercentage > 0 && scrollPercentage > this.currentMaxScroll) {
      this.currentMaxScroll = scrollPercentage;
    }
  };

  private sendMaxScrollYTrackEvent = () => {
    window.removeEventListener("scroll", this.checkAndMaintainMaxScroll);
    window.removeEventListener("beforeunload", this.sendMaxScrollYTrackEvent);

    const trackingInfo: FlexTrackingInfo = {
      moduleName: "blossom",
      action: Action.SCROLL,
      rfrr: `scroll.${this.currentMaxScroll}`,
      linkName: `User scrolled down ${this.currentMaxScroll}% of the page`,
    };

    sendImmediateTrackEvent(trackingInfo, this.analyticsStore);
  };
}
